import { OrganizationInfo } from "@models/organization.model";
import { ProductsInfo } from "@models/products.model";
import { ProjectInfo } from "@models/projects.model";
import { OptionsProps } from "./provider";

export type ActionType = 
    | {
        type: 'updateProjectList'
        options: ProjectInfo[],
      }
    | {
        type: 'updateOrganizationList'
        options: OrganizationInfo[],
      }
    | {
        type: 'updateProductsList'
        options: ProductsInfo[],
      }

export default function OptionsReducer(state: OptionsProps, action: ActionType): OptionsProps {
    switch (action.type) {
        case 'updateProjectList':
            return {
                ...state,
                projectList: action.options
            }
        case 'updateOrganizationList':
            return {
                ...state,
                organazationList: action.options
            }
        case 'updateProductsList':
            return {
                ...state,
                productsList: action.options
            }
        default: 
            throw new Error();
    }
}